import axios from 'axios';
import { getShopId } from '../api/axiosInstance';

const PRODUCT_TYPE_API_BASE_URL = 'https://frontend-prod.blinkz.in/products-by-type';

/**
 * Fetch products by type from external API
 * @param {number} typeId - The product type ID (0, 1, 2, etc.)
 * @param {number} page - Page number for pagination (default: 1)
 * @param {number} limit - Number of products per page (default: 8)
 * @returns {Promise<array>} Array of products or empty array if error
 */
export const fetchProductsByType = async (typeId, page = 1, limit = 8) => {
  try {
    const shopId = getShopId();

    const response = await axios.get(
      `${PRODUCT_TYPE_API_BASE_URL}/${typeId}?page=${page}&limit=${limit}`,
      {
        headers: {
          'Client-Id': shopId,
        },
      }
    );

    if (response.data && response.data.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }

    // Also check if data is directly in response (not nested)
    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }

    return [];
  } catch (error) {
    console.error(`Error fetching products by type ${typeId}:`, error);
    return [];
  }
};

/**
 * Check if products exist for a given type
 * @param {number} typeId - The product type ID
 * @returns {Promise<boolean>} True if products exist, false otherwise
 */
export const checkProductsExistByType = async (typeId) => {
  try {
    const products = await fetchProductsByType(typeId, 1, 1);
    return products.length > 0;
  } catch (error) {
    console.error(`Error checking products for type ${typeId}:`, error);
    return false;
  }
};

/**
 * Check products for multiple types
 * @param {number[]} typeIds - Array of product type IDs to check
 * @returns {Promise<object>} Object with typeId as key and boolean as value
 */
export const checkProductsForMultipleTypes = async (typeIds) => {
  try {
    const results = {};
    
    const promises = typeIds.map(typeId => 
      checkProductsExistByType(typeId).then(exists => {
        results[typeId] = exists;
      })
    );
    
    await Promise.all(promises);
    return results;
  } catch (error) {
    console.error('Error checking products for multiple types:', error);
    return {};
  }
};
